<template>
  <q-td :props="props" :key="colKey">
    <ams-format-date :date="props.row.letzteSubstitutionspruefung" />
  </q-td>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    props: {
      type: Object,
      required: true,
    },
    colKey: {
      type: String,
      required: true,
    },
  },
});
</script>
